import Trainings from "@/app/views/user-center-trainings/trainings.vue";
import TrainingEnd from "@/app/views/user-center-trainings/training-end.vue";
import TrainingPart from "@/app/views/user-center-trainings/training-part.vue";

export const trainingsRoutes = [
    {
        name: "training_home",
        path: "training",
        redirect: { name: "trainings" },
        children: [
            {
                component: Trainings,
                name: "trainings",
                path: "list"
            },
            {
                component: TrainingPart,
                name: "training_part",
                path: "list/:id",
                props: true
            },
            {
                component: TrainingEnd,
                name: "training_complete",
                path: "complete"
            }
        ]
    },
];